import { format, parseISO } from "date-fns";

export default function getDateFormatted(timestamp) {
  const inputDate = parseISO(timestamp);

  const formattedDate = format(inputDate, "d MMM yyyy, h:mma");
  return formattedDate;
}
